import { createAPI } from '@common'

export default {
  // 微信账号列表
  getWeixinAccounts: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout', 'get', config, vConfig),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  getWbPermissions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0benjo0xcqfsnjttjpot0bdujpot0xcdpmvno',
      'get',
      config
    ),
  postWbPermissions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0benjo0xcqfsnjttjpot0bdujpot0xcdpmvno',
      'post',
      config
    ),
  // 获取当前流程
  getOtherAccountDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0np0bddpvout0' + config.id, 'GET', {}),
  // 获取当前流程
  getWeiboAccountDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bddpvout0je', 'GET', config),
  getE5Flows: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gmpxt', 'get', config),
  // 写稿/修改初始化
  getWeiboArticlesCreationInitialization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0dsfbujpo0jojujbmj{bujpo',
      'get',
      config
    ),
  // 读流程的接口
  postWeiboAccountsFlow: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bddpvout0gmpx', 'post', config, vconfig),
  // 添加账号
  getWeiboAccountsAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bddpvout0bee', 'GET', config),
  postWeiboAccountsDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy00xfjcp0bddpvout0efmfuf', 'POST', config),
  // 保存稿件
  postWeiboArticlesCreate: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 微博账号列表
  getWeiboAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bddpvout0mjtu', 'post', config),
  // 写稿/修改 保存
  postWeiboArticles: (config) => createAPI('customEncryptApiName-1/w20xfjcp0bsujdmft', 'POST', config),
  // 删除微博评论
  getWeiboArticlesDeleteDiscuss: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0efmfufEjtdvtt', 'get', config), // 删除微博评论
  //回复复微博评论
  getWeiboArticlesReplayDiscuss: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy00xfjcp0bsujdmft0sfqmbzEjtdvtt', 'get', config),

  // 预览
  getWeiboArticlesPreview: (config) =>
    createAPI('customEncryptApiName-1/w20xfjcp0bsujdmft0qsfwjfx', 'GET', config),
  postWeiboListdata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60mjtuebub', 'POST', config),
  postWeiboConditions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60dpoejujpot', 'GET', config),
  // 微博刷新
  postWeiboArticlesRefresh: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0sfgsfti', 'POST', config),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0efubjmbdujpot', 'get', config),
  // 微博解锁
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0qbqfs0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),

  // 签发稿件到全媒体采编发（发布用的也是这个接口
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 微博发布
  postArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0sfwplf', 'POST', config),
  // 微博发布
  // 微博发布
  postWeiboArticlesPublishImmediately: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0qvcmjtiJnnfejbufmz',
      'POST',
      config
    ),
  // 微博发布
  postWeiboArticlesPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0qvcmjti', 'POST', config),
  // 微博送审
  postWeiboArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0usbotgfs', 'POST', config),
  //校对完成
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0qsppg', 'POST', config),
  //驳回接口
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0sfkfdu', 'POST', config),
  //驳回接口
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0efmfuf', 'POST', config),
  // 通过
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0qbtt', 'POST', config),
  // 微博发布
  postWeiboAccountsUnauthorized: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bddpvout0vobvuipsj{fe', 'POST', config),
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0qspd0usbotgfs', 'POST', config),
  // 回复稿件评论
  getWeiboReplayDiscuss: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0sfqmbzEjtdvtt', 'GET', config),
  getWeiboDiscussList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0ejtdvttMjtu', 'GET', config),
  //  获取稿件详情
  getWeiboArticlesDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0efubjm', 'GET', config),
  getWeiboArticlesEmoList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0fnpMjtu', 'GET', config),
  postE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60mjtuebub', 'post', config)
}
